<template>
  <div id="wangeditor">
    <div ref="editorElem" style="text-align:left;"></div>
  </div>
</template>
<script>
import E from "wangeditor";
import ImgUploader from "models/img-upload.js";
const imgUploader = new ImgUploader();
export default {
  name: "editorElem",
  data() {
    return {
      editor: null,
      editorContent: ""
    };
  },
  props: {
    catchData: {
      type: Function
    },
    content: {
      type: String
    },
    isUpdate: {
      type: Boolean,
      default: true
    }
  }, // 接收父组件的方法
  watch: {
    content(newVal, odlVal) {
      this.editor.txt.html(this.content);
      this.editor.change && this.editor.change();
    },
    isUpdate(newVal) {
      this.editor.$textElem.attr("contenteditable", newVal);
    }
  },
  mounted() {
    this.editor = new E(this.$refs.editorElem);
    this.editor.customConfig.zIndex = 20;
    this.editor.customConfig.debug =
      location.href.indexOf("wangeditor_debug_mode=1") > 0;

    this.editor.customConfig.uploadFileName = "files";

    // this.editor.customConfig.onblur = html => {
    //   console.log('失去焦点', html);
    // }
    this.editor.customConfig.onblur = html => {
      this.editorContent = html;
      this.catchData(this.editorContent); // 把这个html通过catchData的方法传入父组件
    };
    this.editor.customConfig.onchange = html => {
      this.editorContent = html;
      this.catchData(this.editorContent); // 把这个html通过catchData的方法传入父组件
    };

    this.editor.customConfig.uploadImgShowBase64 = true; // base 64 存储图片
    this.editor.customConfig.pasteFilterStyle = false;
    // this.editor.customConfig.uploadImgMaxLength = 1; // 限制一次最多上传  张图片
    this.editor.customConfig.uploadImgTimeout = 8000;
    this.editor.customConfig.customUploadImg = (files, insert) => {
      files.map(item => {
        imgUploader.postImgUpload(item).then(res => {
          let url = res.imgUrl.replace(
            /ydb-kz.oss-cn-.+.aliyuncs.com/,
            "image.8844it.com"
          );
          console.log(url);
          insert(url);
        });
      })
    };
    this.editor.customConfig.uploadImgMaxSize = 2 * 1024 * 1024; // 将图片大小限制为 2M
    this.editor.customConfig.menus = [
      // 菜单配置
      "head", // 标题
      "bold", // 粗体
      "fontSize", // 字号
      "fontName", // 字体
      "italic", // 斜体
      "underline", // 下划线
      "strikeThrough", // 删除线
      "foreColor", // 文字颜色
      "backColor", // 背景颜色
      "link", // 插入链接
      "list", // 列表
      "justify", // 对齐方式
      "quote", // 引用
      // 'emoticon', // 表情
      "image", // 插入图片
      "table", // 表格
      "code", // 插入代码
      "undo", // 撤销
      "redo" // 重复
    ];
    // 下面是最重要的的方法
    this.editor.customConfig.uploadImgHooks = {
      fail: (xhr, editor, result) => {
        // 插入图片失败回调
      },
      success: (xhr, editor, result) => {
        // 图片上传成功回调
      },
      timeout: (xhr, editor) => {
        // 网络超时的回调
      },
      error: (xhr, editor) => {
        // 图片上传错误的回调
      },
      customInsert: (insertImg, result, editor) => {
        // 图片上传成功，插入图片的回调
        var url = result.data;
        insertImg(url);
      }
    };

    this.editor.create(); // 创建富文本实例
    this.editor.$textElem.attr("contenteditable", this.isUpdate);
    if (!this.content) {
      this.editor.txt.html("");
    }
  }
};
</script>
<style lang="scss">
#wangeditor {
  max-width: 100%;
  height: 100%;
  .w-e-toolbar {
    background: #fff !important;
  }
  .w-e-text-container {
    height: 480px !important;
    max-width: 100%;
    .w-e-text {
      ol > li {
        list-style: decimal outside none;
      }
      ul > li {
        list-style: disc outside none;
      }
      table {
        width: 100% !important;
      }
    }
  }
}
</style>
